// extracted by mini-css-extract-plugin
export default {"trust":"Trust_trust__rV551","container":"Trust_container__va1l6","wrap":"Trust_wrap__Ic14A","title":"Trust_title__RxM6O","text":"Trust_text__QISyW"};